import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LoginContent } from '../models/login-credentials.interface';

export const LoginAuthenticationScreenMock: LoginContent = {
  formGroup: new UntypedFormGroup({
    userId: new UntypedFormControl(null),
    password: new UntypedFormControl(null),
    lastName: new UntypedFormControl(null),
    keepMeLoggedIn: new UntypedFormControl(null)
  }),
  loginFormAttributes: {
    errorCount: 0,
    submitAttempt: false,
    isLastNameRequired: false,
    errorAlertBanner: false,
    userIdControlTouched: false,
    passwordControlTouched: false,
    lastNameControlTouched: false,
    keepMeLoggedInTouched: false,
    formAlertSuccessIcon: false
  },
  pageContent: {
    pageHeader: {
      altText: 'logo',
      logoUrl:
        'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png',
      headerTitle: 'Log In To Delta',
      headerSubTitle: '*fields required'
    },
    errors: {
      usernameErrorMessage: 'Login credential is incorrect. Please try again.',
      passwordErrorMessage: 'Login credential is incorrect. Please try again.',
      lastNameErrorMessage: 'Login credential is incorrect. Please try again.',
      alertWarning: 'To continue, please correct the'
    },
    footer: {
      forgotLoginLink: '/user-login/forgotLogin',
      forgotLoginText: 'Forgot Login',
      forgotLoginViewName: 'forgotLogin',
      forgotPasswordLink: '/user-login/resetPassword',
      forgotPasswordText: 'Forgot Password',
      forgotPasswordViewName: 'resetPassword',
      joinSkyMilesLink: '/join-skymiles',
      joinSkyMilesText: 'Join Skymiles',
      accountRecoveryFlowEnabled: true
    },
    forgotPasswordText: 'Forgot Password',
    headerSubTitle: '*fields required',
    headerTitle: 'Log In To Delta',
    isExternalResetPassword: 'false',
    keepMeLoggedInLabel: 'Keep Me Logged In',
    keepMeLoggedInToolTipMsg:
      "<p>Selecting 'Keep Me Logged In' reduces the amount of times you are asked to log in on this device.</p><p>Use this option only on your own personal device to keep your account secure.</p> ",
    lastNameLabel: 'Last Name*',
    lastNameText: 'Last Name*',
    nextDisplayView: {
      button_continue: '',
      button_createPassword: '',
      button_forgotPassword: '',
      button_loginHelp: '',
      button_modal: 'Log In',
      button_resetPassword: '',
      button_sendLogin: '',
      button_wfp: '',
      nextViewName: '',
      nextViewName_createPassword: '',
      nextViewName_email: '',
      nextViewName_forgotPassword: '',
      nextViewName_loginHelp: '',
      nextViewName_resetPassword: '',
      nextViewName_sendLogin: '',
      nextViewName_sqa: '',
      overlayMessage: '',
      refreshUrl: ''
    },
    passwordLabel: 'Password*',
    passwordText: 'Password*',
    srOnlyText: 'Keep Me Logged In',
    toolTipImage: '/content/img',
    userIdLabel: 'SkyMiles Number Or Username*',
    userIdText: 'SkyMiles Number Or Username*',
    viewName: 'loginCredentials'
  },
  authenticationEnabled: {
    loginAuthWithCredentials: {
      id: '1pmPM11HTW',
      pluginTypeId: '7RmQNDWaOnBoudTufx2sEw',
      status: 'USERNAME_PASSWORD_REQUIRED',
      showRememberMyUsername: false,
      showThisIsMyDevice: false,
      thisIsMyDeviceSelected: false,
      showCaptcha: false,
      rememberMyUsernameSelected: false
    },
    userNamePass: true
  }
};
